import React from "react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { JSX } from "react/jsx-runtime";

export function withRouter(Component) {
  function ComponentWithRouterProp(props: JSX.IntrinsicAttributes) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return (
      <Component
        {...props}
        location={location}
        params={params}
        navigate={navigate}
      />
    );
  }

  return ComponentWithRouterProp;
}